<template>
    <EInput :id="id" v-model="val" :placeholder="$t('Type to search')" :disabled="disabled" @keypress.enter.prevent="onSearch">
        <template #input-append>
            <button class="btn btn-primary rounded-right" @click="clearFilter">
                {{ $t('Clear') }}
            </button>
        </template>
    </EInput>
</template>

<script>
export default {
    name: 'ETableFilter',
    props: {
        id: String,
        disabled: Boolean,
        value: [String, Number]
    },
    computed: {
        val: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    methods: {
        onSearch() {
            this.$emit('input', this.value);
        },
        clearFilter() {
            if (this.value.trim() !== '') {
                this.$emit('clear');
            }
        }
    }
};
</script>
